export function copyJsonObject<T>(jsonRef: T): T {
  return JSON.parse(JSON.stringify(jsonRef));
}
